<template>
    <div class="content-wrapper">
        <app-breadcrumb :page-title="$t('container_wizard')"/>
        <div class="card p-primary border-0">
            <app-container-wizard
                :tabs="tabs"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "containerWizard",
    data() {
        return {
            tabs: [
                {
                    name: this.$t('basic_info'),
                    component: "container-wizard-basic-info"
                },
                {
                    name: this.$t('web_container'),
                    component: "container-wizard-web-container"
                },
                {
                    name: this.$t('sstm_container'),
                    component: "container-wizard-sstm_container"
                },
            ],
        };
    }
};
</script>
